import { DocumentStraighteningResult, handleImageInput, withSBErrorHandling } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotDocumentEnhancerImpl = {
    async straightenImage(params) {
        return withSBErrorHandling(async () => new DocumentStraighteningResult(await ScanbotSDKPlugin.straightenDocumentImage(Object.assign(Object.assign({}, params), { image: handleImageInput(params.image) }))));
    },
};
//# sourceMappingURL=DocumentEnhancerImpl.js.map